import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import {
  getTaskById,
  setCreateScheduledTaskData,
} from '../../redux/actions/tasks';
import { StoreState } from '../../types/state';
import EntityData from '../Common/EntityData';
import ScheduledTaskList from './ScheduledTaskList';
import CreateScheduledTaskDialog from './ScheduleTaskDialog';

const TaskDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { task, scheduledTaskData } = useSelector((state: StoreState) => {
    return {
      task: state.tasks.tasks[id],
      scheduledTaskData: state.tasks.scheduledTaskData,
    };
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!task) {
      dispatch(getTaskById(id));
    }
  }, [task, id, dispatch]);

  console.log(id);

  return (
    <div>
      <EntityData entity={task} />
      {scheduledTaskData ? <CreateScheduledTaskDialog /> : null}
      <Button
        onClick={() => {
          dispatch(setCreateScheduledTaskData(task));
        }}
      >
        Schedule this task
      </Button>
      <ScheduledTaskList parentTaskId={id} />
    </div>
  );
};

export default TaskDetails;
